import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import {
  buildPatientDetailPath,
  parsePatientDetailTab,
  type CreateTreatmentPlanLocationState,
} from './patientDetailTabs';

/** Old `/patients/:id/treatment-plans/new` links land on the chart and open the dialog. */
const LegacyCreateTreatmentPlanRedirect: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const tab = parsePatientDetailTab(searchParams.get('tab'));
  const toothNumbers = (searchParams.get('toothNumbers') ?? '')
    .split(/[,;\s]+/)
    .map((part) => Number(part.trim()))
    .filter((num) => Number.isInteger(num) && !Number.isNaN(num));
  const state: CreateTreatmentPlanLocationState = {
    createTreatmentPlan: true,
    ...(toothNumbers.length > 0 ? { toothNumbers } : {}),
  };

  return (
    <Navigate
      to={buildPatientDetailPath(id, tab)}
      replace
      state={state}
    />
  );
};

export default LegacyCreateTreatmentPlanRedirect;
